import BookingHeader from "@features/booking/components/BookingHeader";
import { BookingChrome } from "@features/booking/layouts";
import { ReactNode } from "react";

interface SelectTimeContainerProps {
  children: ReactNode;
}

const SelectTimeContainer = ({ children }: SelectTimeContainerProps) => (
  <BookingChrome>
    <BookingHeader />
    {children}
  </BookingChrome>
);

export default SelectTimeContainer;
